import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { useParamsList } from 'src/hooks/useParamsList.hook'

export function useSyncSentryUser() {
  const { requestId } = useParamsList()

  useEffect(() => {
    if (!requestId) {
      Sentry.setUser(null)
      return
    }
    Sentry.setUser({ id: requestId })
  }, [requestId])

  return null
}
